// TELA PLANTA
import React, { useState, useContext, useEffect } from "react";

import { Back, Hero, LinearGradient, Next, NotificationError } from "../../../../components";

import { Container, Section, NavigateButtons } from "./styles";
import { DataUserContext, NavigateButtonsContext } from "../../../Criare";

import { ThemeContext, DefaultTheme } from "styled-components";
import { sendPlantEspecificador } from "../../../../services/data-service/api";
import eventTypes from "../../../../events/event-types.const";
import HistoryPages from "../../../../events";
import can from "../../../../utils/can";
import FileBase64 from 'react-file-base64';

const Question21: React.FC = () => {
  const { next } = useContext(NavigateButtonsContext);
  const { setUserWhats, token } = useContext(DataUserContext);

  const [plant, setPlant] = useState<string[]>([]);
  const [error, setError] = useState<number>(0);

  const _theme = useContext(ThemeContext);
  const [theme, setTheme] = useState({} as DefaultTheme);

  const [showError, setShowError] = useState<boolean>(false);
  const [fileName, setFileName] = useState<string>();

  useEffect(() => {
    if (_theme.steps) setTheme(_theme);
  }, [_theme]);

  function submit() {
      sendPlantEspecificador(plant, token)
        .then((response) => {
          if(response.status == 'success')
            next(22);
          
        })
      .catch((error) => {
        setShowError(true);
        setError((prevState) => prevState + 1);
        setTimeout(() => {
          setShowError(false);
        }, 3000);
      } );
      
  }
  
  useEffect(() => {
    HistoryPages.emit(eventTypes.SAVE, 21);
  }, []);
 
  async function onDoneHandler(files){
    setPlant( files );
    setFileName('Arquivo selecionado: ' + files.name);
  }

  return (
    <>
      {theme.status === "success" && (
        <Container>
          <Hero
            criare
            image={can(
              theme,
              "theme.steps.etapa_especificador_planta.propriedades.imagens.etapa_especificador_planta_imagemBanner.url"
            )}
            title={can(
              theme,
              "theme.steps.etapa_especificador_planta.propriedades.banner.subtituloBanner"
            )}
          />
          <Section style={{minHeight: '40vh', height: 'auto'}} >
            <p>
              {can(
                theme,
                "theme.steps.etapa_especificador_planta.propriedades.conteudo.titulo"
              )}
            </p>
            <label className="btnSend">
              <FileBase64
                onDone={ onDoneHandler.bind(this) }
                placeholder="Envie a planta do(s) comodo(s)?"
                type="file"
                name="file"
              />
              <span>Escolher Arquivo</span>
            </label>

            <span className="resultFile">{fileName}</span>
            <br />
            <p>
              * Tamanho máximo 10mb <br />
              * Tipo do arquivo: pdf, jpg, jpeg ou png <br />
              * Caso o tamanho do arquivo exceda o limite nosso comercial entrará em contato com você
            </p>

            {showError && (
              <NotificationError message="Verifique o tamanho e extensão do Arquivo!"></NotificationError>
            )}
          </Section>

          <NavigateButtons>
            <Back criare onClick={() => next(HistoryPages.getLastPage())} />
            <Next criare onClick={submit} animationTrigger={error} />
          </NavigateButtons>

          <LinearGradient />
        </Container>
      )}
    </>
  );
};

export default Question21;
